import * as z from 'zod';

// Types
import { TitleZod } from '@/types/TitleType';
import { WaveWrapperZod } from '@/types/WaveWrapperType';
import { ParagraphZod } from '@/components/atoms/Paragraph/ParagraphType';

const FAQZod = z.object({
  __component: z.literal('block.faq'),
  id: z.number(),
  title: TitleZod,
  waveWrapper: WaveWrapperZod.nullable(),
  faqItems: z
    .array(
      z.object({
        id: z.number(),
        question: TitleZod,
        answer: ParagraphZod,
      }),
    )
    .nullable(),
});

export { FAQZod };
export type FAQType = z.infer<typeof FAQZod>;
